import React from "react";
import { useOnlineStatus, getOfflineCacheMeta } from "@/hooks/useOfflineCache";

/**
 * Compact banner shown when the device is offline. Reassures the user
 * that cached products are still browsable.
 */
export function OfflineBanner({ lang = "es" }: { lang?: "es" | "en" }) {
  const online = useOnlineStatus();
  if (online) return null;

  const meta = getOfflineCacheMeta();
  const messages = {
    es: {
      title: "Sin conexión",
      desc: meta
        ? `Mostrando ${meta.count} productos guardados. Algunas acciones se reanudarán al volver online.`
        : "No hay productos guardados todavía. Conéctate para cargar el catálogo.",
    },
    en: {
      title: "You're offline",
      desc: meta
        ? `Showing ${meta.count} cached products. Some actions will resume when you're back online.`
        : "No cached products yet. Connect to load the catalog.",
    },
  } as const;
  const m = messages[lang === "en" ? "en" : "es"];

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        background: "linear-gradient(135deg,#FFF3E0,#FFE0B2)",
        borderBottom: "1px solid #FFB74D",
        padding: "8px 14px",
        display: "flex",
        alignItems: "center",
        gap: 10,
        fontFamily: "var(--f)",
      }}
    >
      <span style={{ fontSize: 18 }}>📡</span>
      <div style={{ flex: 1, lineHeight: 1.3 }}>
        <div style={{ fontSize: 12.5, fontWeight: 700, color: "#E65100" }}>{m.title}</div>
        <div style={{ fontSize: 11, color: "#BF360C" }}>{m.desc}</div>
      </div>
    </div>
  );
}
